export const wheelDetailsPositions = {
    frontLeft: "front_left",
    frontRight: "front_right",
    rearLeft: "rear_left",
    rearRight: "rear_right"
}